// https://www.npmjs.com/package/idb

import { KV, makeIndexedDBStore } from "../dbutil";
import type { Writable } from "svelte/store";

const db = new KV("wcstore", "keyval");

type RecentEntry = {
  name: string;
  dirHandle: FileSystemDirectoryHandle;
};

export let recent: Writable<RecentEntry[]> = makeIndexedDBStore(db, "recent", [], false);
